import queryString from 'query-string';

import { Config, fetchJSON, Languages, noticeError } from '@ratehub/base-ui';

/**
 * @typedef {object} CreditCardListObject
 * @property {string} id - The id of the credit card.
 * @property {string} name - The name of the credit card.
 * @property {string} slug - The slug of the credit card.
 * @property {object} provider - The provider of the credit card.
 */

/**
 * Fetches a list of credit cards with a reduced set of fields.
 * @param {object} [options={}] - The options for fetching the credit card list.
 * @param {string} [options.language=Languages.ENGLISH] - The language for the credit card list.
 * @param {string} [options.province] - The province for the credit card list.
 * @param {boolean} [options.bypassFilters] - Indicates whether to bypass filters for the credit card list.
 * @returns {Promise<Array<CreditCardListObject>>} The list of credit card objects (a subset of CreditCardShape).
 */
async function fetchCreditCardList({
    language = Languages.ENGLISH,
    province,
    bypassFilters,
} = {}) {
    const query = queryString.stringify({
        bypassFilters,
        province,
        language,
    });

    const json = await fetchJSON(`${API_ENDPOINT}?${query}`, 'fetchCreditCardList');

    if (!json?.data?.creditCards) {
        noticeError(
            new Error('[fetchCreditCardList] Error unexpected return value for fetch'),
            {
                json,
                query,
            },
        );
        return [];
    }

    return json.data.creditCards;
}

const API_ENDPOINT = `${Config.CC_API_URL}/card-list` ;

export default fetchCreditCardList;
